import { useEffect, useRef } from 'react';

export const useInfiniteScroll = (
  containerReference: React.RefObject<HTMLElement | null>,
  {
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  }: {
    hasNextPage?: boolean;
    isFetchingNextPage: boolean;
    fetchNextPage: () => void | Promise<unknown>;
  }
) => {
  const sentinelReference = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!hasNextPage || isFetchingNextPage || !containerReference.current) return;

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          fetchNextPage();
        }
      },
      {
        root: undefined,
        rootMargin: '100px',
        threshold: 0.1,
      }
    );

    const sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    sentinel.style.width = '100%';
    sentinelReference.current = sentinel;
    containerReference.current.append(sentinel);
    observer.observe(sentinel);

    return () => {
      observer.disconnect();
      if (sentinelReference.current && containerReference.current?.contains(sentinelReference.current)) {
        sentinelReference.current.remove();
      }
    };
  }, [hasNextPage, isFetchingNextPage, fetchNextPage, containerReference]);
};
